import "./App.css";
import { useState } from "react";
import PlaybookViewer from "./components/PlaybookViewer/PlaybookViewer";
import WelcomePage from "./components/HomePage/WelcomePage";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

function App() {
  const [playbookUrl, setPlaybookUrl] = useState("");
  const [playbookJson, setPlaybookJson] = useState(null);

  const handleUrlSubmit = (url) => {
    setPlaybookUrl(url);
  };

  const handleFileUpload = (json) => { 
    setPlaybookJson(json);
  };
  const params = new URLSearchParams(window.location.search);
  const queryPlaybookURL = params.get("playbook");

  // Update playbookUrl with the URL from the query parameter if it exists
  if (queryPlaybookURL && playbookUrl !== queryPlaybookURL) {
    setPlaybookUrl(queryPlaybookURL);
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {playbookUrl || playbookJson ? (
        <div className="App">
          <PlaybookViewer url={playbookUrl} json={playbookJson} />
        </div>
      ) : (
        <WelcomePage onUrlSubmit={handleUrlSubmit} onFileUpload={handleFileUpload} />
      )}
    </ThemeProvider>
  );
}

export default App;